import { all } from "redux-saga/effects";

import { toastSaga } from "../components/toast/presentation/store/saga";

import { getAllOfficeServersSaga } from "../features/officeServers/presentation/store/getAllOfficeServers/saga";
import { createOfficeServerSaga } from "../features/officeServers/presentation/store/createOfficeServer/saga";
import { updateOfficeServerSaga } from "../features/officeServers/presentation/store/updateOfficeServer/saga";
import { getServerAuditTrailSaga } from "../features/officeServers/presentation/store/getServerAuditTrail/saga";

import { getFinalityLogsSaga } from "../features/finalityLogs/presentation/store/getFinalityLogs/saga";



export default function* RootSaga(dispatch: any) {
  yield all([
    toastSaga(),
    
    getAllOfficeServersSaga(),
    createOfficeServerSaga(),
    updateOfficeServerSaga(),
    getServerAuditTrailSaga(),

    getFinalityLogsSaga(),
  ]);
}
